import { Property } from "../RadObject";
import { IListOfExpression, ListOfExpression, ListOfExpressionPropertyValues } from "./ListOfExpression";
import { NAMESPACE } from "./_Namespace";

export type OrExpressionPropertyValues =
    ListOfExpressionPropertyValues
    & {
    };

export type OrExpressionProperties = {
    [name in keyof OrExpressionPropertyValues]: Property<OrExpressionPropertyValues[name]>
};

export interface IOrExpression extends IListOfExpression, OrExpressionProperties
{
}

export class OrExpression extends ListOfExpression<OrExpressionPropertyValues> implements IOrExpression
{
    public static override classNamespace = NAMESPACE + "OrExpression";
    public static override className = "OrExpression";
}